<template>
  <div class="text-translation-section">
    <div class="text-translation-section_title">{{$t('intelligentTranslation.textTranslation')}}
    </div>
    <div class="text-translation-section_operation">
      <ul class="operation-left">
        <li class="operation-left_item">
          <el-select class="source-select" size="small" v-model="formData.sourceLang" clearable
                     :placeholder="$t('intelligentTranslation.automaticDetection')"
                     @change="handleChangeSourceLang">
            <el-option v-for="item in selectOption.sourceLangOptions" :key="item.sourceLang"
                       :label="$i18n.locale==='zh'?item.sourceLangName:getEnlang(item.sourceLang)"
                       :value="item.sourceLang">
            </el-option>
          </el-select>
          <i class="language-btn"></i>
          <el-select size="small" v-model="formData.targetLang" clearable
                     :no-data-text="$t('newProjectV2.firstSelSourceLangTip')"
                     :placeholder="$t('jobManagementV2.selectText')">
            <el-option v-for="item in selectOption.targetLangOptions" :key="item.targetLang"
                       :label="$i18n.locale==='zh'?item.targetLangName:getEnlang(item.targetLang)"
                       :value="item.targetLang">
            </el-option>
          </el-select>
        </li>
        <li class="operation-left_item">
          <el-select size="small" v-model="formData.domainCode" clearable
                     :placeholder="$t('memoryBankV2.pleaseDomain')">
            <el-option v-for="item in selectOption.domainOptions" :key="item.dataKey"
                       :label="$i18n.locale==='zh'?item.dataDesc:getEnDomain(item.dataKey)"
                       :value="item.dataKey">
            </el-option>
          </el-select>
        </li>
      </ul>
      <div class="operation-right">
        <el-button size="small" type="primary" v-throttle="getSentTranslation">
          <i class="btn-icon trans-btn"></i>
          <span>{{$t('newProjectV2.translation')}}</span>
        </el-button>
      </div>
    </div>
    <div class="text-translation-warp">
      <div class="trans-view">
        <el-tooltip effect="dark" :content="$t('common.reset')" placement="top-start">
          <i class="clear el-icon-close" v-show="isShowClear" @click.stop="handleClearSent">
          </i>
        </el-tooltip>
        <div class="trans-view-source" ref="transViewSource">
          <div class="textarea-light-text" ref="textareaLightText" v-html="highlightSourceText">
          </div>
          <el-input ref="sourceTextarea" v-model="sourceSent" type="textarea" resize="none"
                    :maxlength="maxTransWordSize" autosize
                    :placeholder="$t('intelligentTranslation.pleaseEnterTransContent')"
                    @input="handleInputSourceSent" @focus="handleFocusSourceSent" @paste.native="onPaste" 
                    @blur="handleBlurSourceSent">
          </el-input>
        </div>
        <div class="trans-view-target" ref="transViewTarget" :contenteditable="isTargetEditor"
             @blur="handleBlurTargetSent" @scroll="handleScrollRight($event)">
          <p class="target-output" v-for="(item,index) in targetSentList" :key="index">
            <span :class="{'target-active':textItem.isMouseover}"
                  v-for="(textItem,textIndex) in item" :key="textIndex" v-html="textItem.targetSent"
                  @mouseover="handleTargetMouseover(textItem,index,textIndex)"
                  @mouseout="handleTargetMouseout(textItem)">
            </span>
          </p>
        </div>
        <div class="trans-info-word-num">{{charSize}}/{{maxTransWordSize}}</div>
      </div>
      <div class="trans-info">
        <div class="trans-info-left">
          <div class="trans-time" v-html="$t('intelligentTranslation.transTime',[transTime])"></div>
          <div class="split-line"></div>
          <div class="trans-speed"
               v-html="$t('intelligentTranslation.transSpeed',[charactersPerSecond])"></div>
        </div>
        <div class="trans-info-right">
          <el-tooltip effect="dark" placement="top-start"
                      :content="$t('intelligentTranslation.copyTarget')">
            <i class="trans-info-icon icon-copy" @click="handleCopy"></i>
          </el-tooltip>
          <el-tooltip effect="dark" placement="top-start"
                      :content="$t('intelligentTranslation.editorTarget')">
            <i class="trans-info-icon icon-editor-target" @click="handleEditorTarget"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="translation-record">
      <div class="translation-record-title">{{$t('intelligentTranslation.recentTransRecords')}}:
      </div>
      <ul class="translation-record-content">
        <el-tooltip v-for="(item,index) in historyList" :key="index"
                    :disabled="item.sourceSent.length<=10" popper-class="history-trans-tooltip"
                    effect="dark" placement="top-start">
          <div slot="content" v-html="item.sourceSentHTML"></div>
          <!-- @mouseover=" mouseOverShowTips($event)" -->
          <li class="translation-record-content_item" @click="handleTransHistory(item)">
            {{item.sourceSent.length>10?`${item.sourceSent.slice(0,11)}...`:item.sourceSent}}
          </li>
        </el-tooltip>
      </ul>
    </div>
  </div>
</template>

<script>
import { getLang, getOptionList } from '@/services/memoryBank';
import { textLangRecognition, getSentTranslation } from '@/services/transApi';
import { onCopy } from '@/utils';
// import ExceedTips from '@/mixins/ExceedTips';
import _ from 'lodash';
export default {
  name: 'TextTranslation',
  // mixins: [ExceedTips],
  data () {
    return {
      maxTransWordSize: 5000,          // 最大可翻译的字数
      formData: {                      // 下拉绑定值
        sourceLang: '',
        targetLang: '',
        domainCode: ''
      },
      selectOption: {                 // 下拉选择列表
        sourceLangOptions: [],
        targetLangOptions: [],
        domainOptions: []
      },
      sourceSent: '',                 // 原文 文本域绑定值
      targetSentList: [],             // 译文列表
      transTime: 0,                   // 翻译用时
      charSize: 0,
      charactersPerSecond: 0,         // 字/每秒
      isTargetEditor: false,          // 是否允许编辑译文
      onCopy: null,                   // 用于承载copy工具函数
      highlightSourceText: '',        // 高亮原文内容
      historyList: [],                // 历史记录列表
      isMouseoverAll: true,           // 是否允许全部译文进行高亮对照
      isNewInput:true,                //是否是重新输入
      isSelectAll:true,               //是否全部划词选中
      isSelectAllAndPaste:true,       //是否全部选中然后粘贴
    }
  },

  computed: {
    isShowClear () {
      return this.sourceSent && this.sourceSent.length > 0 ? true : false
    }
  },
  watch:{
    sourceSent(newVal,oldVal){
      if(newVal === ''){
        console.log('输入框已清空');
        this.isNewInput = true
      }
      this.charSize = newVal.length 
    }
  },

  created () {
    this.onCopy = onCopy
    this.historyList = JSON.parse(localStorage.getItem('fy-cat_transHistory')) || []
  },

  mounted () {
       // 将 mouseup 事件绑定到文档对象上
       document.addEventListener('mouseup', this.onMouseUp);

    this.$nextTick(() => {
      this.setSourceTextareaHeight()
      this.getLangList({ type: 1 })
      this.getDomainList()
      window.addEventListener('resize', this.setSourceTextareaHeight)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setSourceTextareaHeight)
  },
  destroyed() {
    // 在组件销毁时，移除 mouseup 事件的监听器
    document.removeEventListener('mouseup', this.onMouseUp);
  },


  methods: {
    // 初始化原文文本域框高度
    setSourceTextareaHeight: _.debounce(function () {
      this.$nextTick(() => {
        const textareaLightTextHeight = this.$refs.textareaLightText.clientHeight
        const sourceTextareaDom = this.$refs.sourceTextarea.$el.childNodes[0]
        sourceTextareaDom.style['min-height'] = `${textareaLightTextHeight}px`
      })
    }, 1000, {
      leading: true,
      trailing: false
    }),

    // 获取语言
    async getLangList (params) {
      const { success, result } = await getLang(params)
      if (!success) return
      if (params.type === 1) {
        this.selectOption.sourceLangOptions = result
      } else if (params.type === 2) {
        this.selectOption.targetLangOptions = result.filter(item => item.status === 1)
      }
    },

    // 获取领域
    async getDomainList () {
      const params = {
        dataType: 'trans_domain'
      }
      const { success, result } = await getOptionList(params)
      if (!success) return
      this.selectOption.domainOptions = result.filter(item=>item.creatorId == 0)
    },

    // 源语言change
    handleChangeSourceLang () {
      this.formData.targetLang = ''
      if (this.formData.sourceLang === '') {
        this.selectOption.targetLangOptions = []
        return
      }
      const targetLangParams = { type: 2, sourceLang: this.formData.sourceLang }
      this.getLangList(targetLangParams)
    },
    //粘贴事件
    onPaste(event) {
      // 获取当前剪贴板中的内容
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');

      // 判断是否粘贴替换操作
      if ( pastedData && this.isSelectAll) {
        console.log('输入框中的文本被全部选中并粘贴替换了');
        this.isSelectAllAndPaste = true
        this.isSelectAll = false 
      }
    },
    //判断输入框中的文本是否被全部划词选中
    onMouseUp() {
      const input = this.$refs.sourceTextarea.$refs.textarea
      // 获取当前光标所在位置
      const start = input.selectionStart;
      const end = input.selectionEnd;

      // 判断是否全部选中
      if (start === 0 && end === this.sourceSent.length) {
        console.log('输入框中的文本已被全部选中');
        this.isSelectAll = true
      }else{
        this.isSelectAll = false
      }
    },
    // 原文输入框 聚焦事件
    handleFocusSourceSent () {
      this.$nextTick(() => {
        const transViewSourceDom = this.$refs.transViewSource
        transViewSourceDom.style['border-color'] = '#0078fc'
      })
    },

    // 原文输入框 失焦事件
    handleBlurSourceSent () {
      this.$nextTick(() => {
        const transViewSourceDom = this.$refs.transViewSource
        transViewSourceDom.style['border-color'] = '#E5E7EB'
      })
    },

    // 原文 input 触发
    handleInputSourceSent: _.debounce(async function () {
      if (this.sourceSent.replace(/\s/g, '') === '') {
        this.targetSentList = []
        return
      }
      await this.textLangRecognition()
      this.formData.domainCode = this.selectOption.domainOptions.length ? this.selectOption.domainOptions[0].dataKey : ''
      await this.getSentTranslation()
    }, 1000, {
      leading: false,
      trailing: true
    }),

    // 语言自动检测
    async textLangRecognition () {
      if (this.sourceSent.replace(/\s/g, '') === '') return
      const params = {
        sourceSent: this.sourceSent
      }
      const { success, result } = await textLangRecognition(params)
      if (!success) return
      this.formData.sourceLang = result.langCode ? result.langCode : ''
      // this.formData.targetLang = ''
      if (this.formData.sourceLang) {
        const targetLangParams = { type: 2, sourceLang: this.formData.sourceLang }
        await this.getLangList(targetLangParams)
        // this.formData.targetLang = this.selectOption.targetLangOptions.length ? this.selectOption.targetLangOptions[0].targetLang : ''
        if(!this.formData.targetLang){
          this.formData.targetLang = this.selectOption.targetLangOptions[0].targetLang
        }
      }
    },

    // 文本翻译
    async getSentTranslation () {
      if (this.sourceSent.replace(/\s/g, '') === '') {
        this.$message.closeAll()
        this.$message.error(this.$t('intelligentTranslation.textNotEmpty'))
        return
      }
      const params = {
        ...this.formData,
        text: this.sourceSent.replace(/ {1,}\n{1,}/g,
          function (exp) {
            return exp.replace(/ {1,}/g, '')
          })
      }
      if (!(Object.values(params).every(item => Boolean(item)))) return
      const startTransTime = +new Date()
      const { success, result } = await getSentTranslation(params)
      if (!success) return
      // this.charSize = result.charSize
      this.targetSentList = result.sentList || []
      if (this.targetSentList.length) {
        this.targetSentList.forEach(arr => {
          if (arr && arr.length) {
            console.log(arr, 'arr');
            arr.forEach(item => {
              this.$set(item, 'isMouseover', false)
              // item.targetSent = item.targetSent.replace(/ /g, '&nbsp;')
              // item.sourceSent = item.sourceSent.replace(/ /g, '&nbsp;')
            })
            // 将后台返回的数据中 每一个大段落的最后一句原文加上换行标签
            arr[arr.length - 1].sourceSent += '<br/>'
          } else if (arr && !arr.length) { // 如果当前大段落为空数组，默认为换行标签
            arr.push({
              sourceSent: '<br/>',
              targetSent: '<br/>',
              // isMouseover: false
            })
          }
        })
      }
      this.transTime = ((+new Date() - startTransTime) / 1000).toFixed(2)
      this.charactersPerSecond = parseInt(this.charSize / this.transTime)
      // 历史记录处理
      console.log('输入框已清空',this.isNewInput);
      let arr = JSON.parse(localStorage.getItem('fy-cat_transHistory')) || []
      if(this.isNewInput || this.isSelectAllAndPaste){
        arr.unshift({
          ...this.formData,
          sourceSentHTML: this.sourceSent.replace(/(\n)/g, '<br/>'),
          sourceSent: this.sourceSent
        })
      }else{
        arr[0]={
          ...this.formData,
          sourceSentHTML: this.sourceSent.replace(/(\n)/g, '<br/>'),
          sourceSent: this.sourceSent
        }
      }
      this.isNewInput = false
      this.isSelectAllAndPaste = false
      let map = new Map()
      for (const item of arr) {
        map.set(item.sourceSent, item)
      }
      this.historyList = [...map.values()]
      localStorage.setItem('fy-cat_transHistory', JSON.stringify(this.historyList))
    },

    // 译文框 失焦事件
    handleBlurTargetSent () {
      this.isTargetEditor = false
      this.isMouseoverAll = true
    },

    // 译文框点击编辑 
    handleEditorTarget () {
      this.isTargetEditor = true
      this.isMouseoverAll = false
    },
    // 复制译文
    handleCopy () {
      const transViewTargetDom = this.$refs.transViewTarget
      const text = transViewTargetDom.innerText
      this.onCopy(text)
    },

    // 译文鼠标悬浮事件
    handleTargetMouseover (textItem, index, currentMouseoverIndex) {
      if (!this.isMouseoverAll) return
      if ('isMouseover' in textItem) {
        textItem.isMouseover = true
        const sliceObj = {
          startArr: this.targetSentList.slice(0, index),
          selectArr: this.targetSentList.slice(index, index + 1),
          lastArr: this.targetSentList.slice(index + 1),
        }
        this.setHighlightingContent(sliceObj, currentMouseoverIndex)
      }
    },

    // 译文鼠标离开事件
    handleTargetMouseout (textItem) {
      if (!this.isMouseoverAll) return
      if ('isMouseover' in textItem) {
        textItem.isMouseover = false
        this.highlightSourceText = ''
      }
    },

    // 设置高亮内容
    setHighlightingContent (obj, currentMouseoverIndex) {
      const result = {
        startStr: '',
        selectStr: '',
        lastStr: ''
      }
      // console.log(obj, 'obj');
      obj.startArr.forEach(arr => {
        if (arr.length) {
          arr.forEach(item => {
            result.startStr += item.sourceSent
          })
        }
      })
      obj.selectArr.forEach(arr => {
        if (arr.length) {
          arr.forEach((item, index) => {
            if (currentMouseoverIndex > index && !item.isMouseover) {
              result.startStr += item.sourceSent
            } else if (currentMouseoverIndex === index && item.isMouseover) {
              result.selectStr += `<span class="high-light-bg" >${item.sourceSent}</span>`
            } else {
              result.lastStr += item.sourceSent
            }
          })
        }
      })

      obj.lastArr.forEach(arr => {
        if (arr.length) {
          arr.forEach(item => {
            result.lastStr += item.sourceSent
          })
        }
      })

      for (const key in result) {
        this.highlightSourceText += result[key]
      }
    },

    // 右侧译文框 滚动
    handleScrollRight (e) {
      let rightHeight = e.target.scrollHeight;
      let rightTop = e.target.scrollTop;
      let leftDom = this.$refs.transViewSource
      if (leftDom) {
        // 高度比乘以一侧的滚动高度
        leftDom.scrollTop = parseInt(
          (leftDom.scrollHeight * rightTop) / rightHeight
        );
      }
    },

    // 清除原译文内容
    handleClearSent () {
      this.sourceSent = ''
      this.targetSentList = []
    },

    // 点击历史记录
    async handleTransHistory (data) {
      this.isNewInput = true //也算做重新输入
      this.sourceSent = data.sourceSent
      if (this.sourceSent.replace(/\s/g, '') === '') return
      const textarea = this.$refs.sourceTextarea
      textarea.select()
      await this.textLangRecognition()
      this.formData.domainCode = this.selectOption.domainOptions.length ? this.selectOption.domainOptions[0].dataKey : ''
      await this.getSentTranslation()
    }

  },
}
</script>

<style lang="less" scoped>
@import "./assets/index.less";
</style>

<style lang="less">
.history-trans-tooltip {
  max-width: 70%;
  div {
    max-height: 300px;
    overflow-y: auto;
    padding: 0px;
    line-height: 16px;
  }
}
</style>